import { Button } from '@components/common';

import { useModal } from '@components/common/Modal/utils';

import { IRUConfiguration } from '@interfaces/cmModule/ruConfiguration';

import styles from './ViewRUConfigurationModal.module.scss';

interface IViewRUConfigurationModalProps {
	configuration?: IRUConfiguration;
}

export const ViewRUConfigurationModal = ({
	configuration,
}: IViewRUConfigurationModalProps) => {
	const { onClose } = useModal();

	const {
		networkElementName,
		ruMacAddress,
		duMacAddress,
		cuPlaneVlanId,
		mimoMode,
		txRxArrayCarriers,
	} = configuration || {};

	const {
		absoluteFrequencyCenter: nrafrcn,
		centerOfChannelBandwidth: frequency,
		channelBandwidth,
		gain,
	} = txRxArrayCarriers?.[0] || {};

	return (
		<div className={styles.container}>
			<div className={styles.detailsContainer}>
				<div className={styles.details}>
					<div className={styles.title}>Name</div>
					<div className={styles.value}>{networkElementName}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>CU VLAN-ID</div>
					<div className={styles.value}>{cuPlaneVlanId}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>O_RU Mac Address</div>
					<div className={styles.value}>{ruMacAddress}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>O-DU Mac Address</div>
					<div className={styles.value}>{duMacAddress}</div>
				</div>
				<div className={styles.separator}>Carriers data</div>
				<div className={styles.details}>
					<div className={styles.title}>MIMO mode</div>
					<div className={styles.value}>{mimoMode?.name || '-'}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>Frequency (Hz)</div>
					<div className={styles.value}>{frequency || '-'}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>NR ARFCN</div>
					<div className={styles.value}>{nrafrcn || '-'}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>Channel Bandwidth (Hz) </div>
					<div className={styles.value}>{channelBandwidth || '-'}</div>
				</div>
				<div className={styles.details}>
					<div className={styles.title}>Transmission Gain (dB)  </div>
					<div className={styles.value}>{gain || '-'}</div>
				</div>
			</div>
			<Button
				className={styles.button}
				onClick={onClose}
				text='Close'
				withoutBackground
			/>
		</div>
	);
};

export default ViewRUConfigurationModal;
